var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83238 3.99444C2.80244 3.97264 2.77968 3.96024 2.76205 3.94283C1.93293 3.13396 1.10423 2.32468 0.275312 1.5156C0.104321 1.34879 0.0102153 1.14897 0.00283439 0.912744C-0.00885202 0.542508 0.204578 0.215476 0.549019 0.0708618C0.885259 -0.0703516 1.27706 0.00305552 1.54236 0.25928C1.76625 0.475701 1.98809 0.693922 2.21095 0.911543C3.04232 1.72362 3.87328 2.5361 4.70548 3.34738C5.09625 3.72841 5.09913 4.26607 4.70835 4.6477C3.65534 5.6762 2.60316 6.7049 1.54872 7.7316C1.29613 7.97742 0.988797 8.05743 0.647021 7.95902C0.310166 7.86201 0.0963258 7.63519 0.022722 7.29956C-0.0457561 6.98793 0.0413792 6.7123 0.272852 6.48588C1.10074 5.6758 1.93006 4.86712 2.75898 4.05805C2.77702 4.04044 2.79691 4.02504 2.83258 3.99464L2.83238 3.99444Z",
    fill: "#1A293E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.18054019a28083cbbd4c5a5b217fd3e5.svg";
export { ForwardRef as ReactComponent };